import useTooltipService from "shared/components/tooltip/service";
import React from "react";
import { BaseButtonComponent } from "../..";
import { ButtonComponentType } from "../../types";

/**
 * Tooltip handler component for button
 * @remark Do not use this directly. To show tooltip on button pass tooltipContent in Button component.
 */
export default function ButtonWithTooltip(props: ButtonComponentType) {
  const service = useTooltipService({ ...props.tooltipConfig, content: props.tooltipContent });
  return (
    <React.Fragment>
      <BaseButtonComponent {...props} setTriggerRef={service.setTriggerRef} />
      {service.tooltipPortal}
    </React.Fragment>
  );
}
